export function storeOtpDelivery(delivery, emailDeliveryFailed) {
  const mode = emailDeliveryFailed ? 'log_only' : delivery || 'email';
  sessionStorage.setItem('auth_otp_delivery', mode);
}

export function getOtpSubtitle(email) {
  const delivery = sessionStorage.getItem('auth_otp_delivery') || 'email';
  const target = email || 'your email';

  if (delivery === 'skipped') {
    return 'This test account does not receive email OTP. Use the code provided by your admin or check server logs in development.';
  }
  if (delivery === 'log_only') {
    return `OTP was generated but email may not have been delivered. Check server logs or try Resend OTP. (${target})`;
  }
  return `OTP sent to ${target}`;
}

export function getOtpResendSuccessMessage(delivery, emailDeliveryFailed) {
  const mode = emailDeliveryFailed ? 'log_only' : delivery || 'email';
  if (mode === 'skipped') {
    return 'A new OTP was generated (email delivery skipped for this test account).';
  }
  if (mode === 'log_only') {
    return 'A new OTP was generated but email may not have been delivered. Check server logs or try again.';
  }
  return 'A new OTP has been sent to your email.';
}
